import * as React from 'react';
import { Helmet } from 'react-helmet';

interface Props {}

export class HeadSection extends React.PureComponent<Props> {
  render(): React.ReactNode {
    return (
      <Helmet>
        <title>Preview Your Wedding Website — Joy</title>
        <meta
          name="description"
          content="Preview your wedding website design. Change layouts, themes, colors, and fonts to make it uniquely yours."
        />
        <style type="text/css">
          {`
        html {
          font-size: 16px;
        }
        body {
          font-size: 1rem;
          overflow: hidden;
        }
      `}
        </style>
      </Helmet>
    );
  }
}
